import { SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Input, Popconfirm, Row, Space, Table, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from '../../Images/ArchiveRestore.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';

export default function ArchiveExcessStock() {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pagesize, setPageSize] = useState(10);
    const [orderBy, setOrderBy] = useState('');
    const dispatch = useDispatch();


    const { data = [], totalRecord, status } = useSelector(state => state.quotation);

    const dataSource = data.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
    }));

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const debounceTimeout = useRef(null);
    const handleSearch = (e) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            setSearch(e.target.value);
            setPage(1);
        }, 100); // 300ms delay
    };
    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = "id";

        if (sortField === "bundle_number" && sortOrder === "ascend") {
            sortingEnumKey = "bundle_number";
        }
        if (sortField === "bundle_number" && sortOrder === "descend") {
            sortingEnumKey = "-bundle_number";
        }
        if (sortField === "section" && sortOrder === "ascend") {
            sortingEnumKey = "section";
        }
        if (sortField === "section" && sortOrder === "descend") {
            sortingEnumKey = "-section";
        }
        if (sortField === "die_image" && sortOrder === "ascend") {
            sortingEnumKey = "die_image";
        }
        if (sortField === "die_image" && sortOrder === "descend") {
            sortingEnumKey = "-die_image";
        }
        if (sortField === "item_name" && sortOrder === "ascend") {
            sortingEnumKey = "item_name";
        }
        if (sortField === "item_name" && sortOrder === "descend") {
            sortingEnumKey = "-item_name";
        }
        if (sortField === "length" && sortOrder === "ascend") {
            sortingEnumKey = "length";
        }
        if (sortField === "length" && sortOrder === "descend") {
            sortingEnumKey = "-length";
        }
        if (sortField === "pieces" && sortOrder === "ascend") {
            sortingEnumKey = "pieces";
        }
        if (sortField === "pieces" && sortOrder === "descend") {
            sortingEnumKey = "-pieces";
        }
        if (sortField === "weight" && sortOrder === "ascend") {
            sortingEnumKey = "weight";
        }
        if (sortField === "weight" && sortOrder === "descend") {
            sortingEnumKey = "-weight";
        }
        if (sortField === "avg" && sortOrder === "ascend") {
            sortingEnumKey = "avg";
        }
        if (sortField === "avg" && sortOrder === "descend") {
            sortingEnumKey = "-avg";
        }
        if (sortField === "packing_date" && sortOrder === "ascend") {
            sortingEnumKey = "packing_date";
        }
        if (sortField === "packing_date" && sortOrder === "descend") {
            sortingEnumKey = "-packing_date";
        }
        if (sortField === "alloy" && sortOrder === "ascend") {
            sortingEnumKey = "alloy";
        }
        if (sortField === "alloy" && sortOrder === "descend") {
            sortingEnumKey = "-alloy";
        }
        if (sortField === "temper" && sortOrder === "ascend") {
            sortingEnumKey = "temper";
        }
        if (sortField === "temper" && sortOrder === "descend") {
            sortingEnumKey = "-temper";
        }
        if (sortField === "status" && sortOrder === "ascend") {
            sortingEnumKey = "status";
        }
        if (sortField === "status" && sortOrder === "descend") {
            sortingEnumKey = "-status";
        }
        if (sortField === "customer" && sortOrder === "ascend") {
            sortingEnumKey = "customer";
        }
        if (sortField === "customer" && sortOrder === "descend") {
            sortingEnumKey = "-customer";
        }
        if (sortField === "total_weight" && sortOrder === "ascend") {
            sortingEnumKey = "total_weight";
        }
        if (sortField === "total_weight" && sortOrder === "descend") {
            sortingEnumKey = "-total_weight";
        }
        if (sortField === "total_pieces" && sortOrder === "ascend") {
            sortingEnumKey = "total_pieces";
        }
        if (sortField === "total_pieces" && sortOrder === "descend") {
            sortingEnumKey = "-total_pieces";
        }
        if (sortField === "total_bundles" && sortOrder === "ascend") {
            sortingEnumKey = "total_bundles";
        }
        if (sortField === "total_bundles" && sortOrder === "descend") {
            sortingEnumKey = "-total_bundles";
        }
        if (sortField === "created_at" && sortOrder === "ascend") {
            sortingEnumKey = "created_at";
        }
        if (sortField === "created_at" && sortOrder === "descend") {
            sortingEnumKey = "-created_at";
        }
        if (sortField === "created_by" && sortOrder === "ascend") {
            sortingEnumKey = "created_by";
        }
        if (sortField === "created_by" && sortOrder === "descend") {
            sortingEnumKey = "-created_by";
        }
        if (sortField === "updated_at" && sortOrder === "ascend") {
            sortingEnumKey = "updated_at";
        }
        if (sortField === "updated_at" && sortOrder === "descend") {
            sortingEnumKey = "-updated_at";
        }
        if (sortField === "updated_by" && sortOrder === "ascend") {
            sortingEnumKey = "updated_by";
        }
        if (sortField === "updated_by" && sortOrder === "descend") {
            sortingEnumKey = "-updated_by";
        }
        return sortingEnumKey;
    };

    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        if (sorter?.columnKey && sorter.order) {
            const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
            setOrderBy(orderBy);
        }
        setPageSize(pagination.pageSize);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: setSelectedRowKeys,
    };
    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo', // Use a unique key for the serial number
            key: 'SrNo',
            sorter: true,
            width: '8%',
        },
        {
            title: 'Bundle No',
            dataIndex: 'bundle_number',
            key: 'bundle_number',
            sorter: true,
        },
        {
            title: 'Section',
            dataIndex: 'section',
            key: 'section',
            sorter: true,
        },
        {
            title: 'Die Image',
            dataIndex: 'die_image',
            key: 'die_image',
            sorter: true,
        },
        {
            title: 'Item Name',
            dataIndex: 'item_name',
            key: 'item_name',
            sorter: true,
        },
        {
            title: 'length(mm)',
            dataIndex: 'length',
            key: 'length',
            sorter: true,
        },

        {
            title: 'Pieces',
            dataIndex: 'pieces',
            key: 'pieces',
            sorter: true,
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
        },
        {
            title: 'Avg Wt(kg)',
            dataIndex: 'avg',
            key: 'avg',
        },
        {
            title: 'Packing Date',
            dataIndex: 'packing_date',
            key: 'packing_date',
        },
        {
            title: 'Alloy',
            dataIndex: 'alloy',
            key: 'alloy',
        },
        {
            title: 'Temper',
            dataIndex: 'temper',
            key: 'temper',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Customer Name',
            dataIndex: 'customer',
            key: 'customer',
        },
        {
            title: 'Total Weight(kg)',
            dataIndex: 'total_weight',
            key: 'total_weight',
        },
        {
            title: 'Total Pieces',
            dataIndex: 'total_pieces',
            key: 'total_pieces',
        },
        {
            title: 'Total Bundles',
            dataIndex: 'total_bundles',
            key: 'total_bundles',
        },
        {
            title: 'Archive At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            render: (record) => {
                return record ? (
                    <span>{dayjs(record).format('DD-MM-YYYY HH:mm')}</span>
                ) : (
                    <span>N/A</span>
                );
            }
        },
        {
            title: 'Archive By',
            dataIndex: 'updated_by',
            key: 'updated_by',
            render: (record) => {
                return (
                    <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'} </span>
                )
            }

        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, record) => (
                <Space>
                    <Tooltip placement="top" title="Restore">
                        <Popconfirm
                            title="Are you sure you want to Unarchive this record?"
                            okText="Yes"
                            cancelText="No"
                        >
                            <ArchiveRestore className="ArchiverestorImg" />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
        },
    ];
    const handlePageChange = (newPage) => {
        setPage(newPage);
        setOrderBy('')
    };
    const resetFilter = () => {
        setSearch('');
        setOrderBy('');
        setPage(1);
    };
    return (
        <>
            <div className='sticyaction'>
                <Row className="pagenamerow" justify="space-between" align="middle">
                    <Col>
                        <h2>Archive Excess Stock</h2>
                        <div className="bredcrumbwrp">
                            <Link to="/excess-stock" className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/dashboard">Home</Link> },
                                    { title: <Link to="/excess-stock">Excess Stock</Link> },
                                    { title: 'Archive Current Stock' }
                                ]}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Space size="middle">
                            <Input placeholder="Search"
                  className='searchbox'
                                value={search}
                                onChange={handleSearch}
                                prefix={<SearchOutlined />} style={{ width: 200 }} />
                            <Link>
                                <Tooltip title="Filter">
                                    <Button type="primary" disabled={!search && !orderBy} className='iconlink' onClick={resetFilter}>
                                        <FilterIcon />
                                    </Button>
                                </Tooltip>
                            </Link>
                        </Space>
                    </Col>
                </Row>
            </div>

            <Table
                rowSelection={rowSelection}
                dataSource={dataSource}
                columns={columns}
                pagination={{
                    defaultCurrent: page,
                    defaultPageSize: pagesize,
                    total: totalRecord,
                    showTotal: (total) => `Total ${total} items`,
                    showSizeChanger: true,
                    onChange: handlePageChange,
                    locale: {
                        items_per_page: 'Items / Page', // Text for the size changer
                    },
                }}
                className="mt-5"
                onChange={handleTableChange}

                scroll={{
                    x: 880,
                }}
            />
        </>
    );
}
